import React from 'react';
const rows = [{
  before: 'Late nights scouring YouTube or Instagram for drills.',
  after: 'Ready-to-use sessions on your tablet in 2 clicks.'
}, {
  before: 'Stress before arriving at the pitch, not knowing what to run.',
  after: 'Total confidence leading your squad.'
}, {
  before: "Confusing explanations that players don't understand.",
  after: 'Crystal clear diagrams and pro-standard graphics.'
}, {
  before: 'Repetitive drills and a demotivated squad.',
  after: 'Constant, stimulating technical progression.'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        {/* Time cost callout */}
        <div className="bg-badge-red/10 border border-badge-red/20 rounded-2xl p-6 sm:p-8 mb-12 text-center" data-id="element-58">
          <p className="text-text-main text-lg sm:text-2xl font-bold leading-relaxed" data-id="element-59">
            Designing every single training session by hand takes, on average,{' '}
            <span className="text-badge-red font-black" data-id="element-60">
              3 to 5 hours a week
            </span>
            . That's{' '}
            <span className="text-badge-red font-black" data-id="element-61">
              over 150 hours a year lost forever among messy papers and
              half-finished diagrams.
            </span>
          </p>
        </div>

        <div className="bg-bg-alt rounded-2xl shadow-2xl border border-border-light overflow-hidden" data-id="element-62">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-white/5" data-id="element-63">
            <div className="px-6 py-5 font-bold text-red-400 text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm" data-id="element-64">
              WITHOUT THE READY-PACK (Your life today)
            </div>
            <div className="px-6 py-5 font-black text-primary text-center md:text-left tracking-wider text-sm" data-id="element-65">
              WITH THE READY-PACK (Your life tomorrow)
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-66">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-white/[0.02] transition-colors" data-id="element-67">
                <div className="px-6 py-6 flex items-start gap-4 border-b md:border-b-0 md:border-r border-border-light bg-black/20" data-id="element-68">
                  <div className="w-6 h-6 rounded-full bg-badge-red/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/30" data-id="element-69">
                    <span className="text-badge-red font-bold text-sm" data-id="element-70">✕</span>
                  </div>
                  <p className="text-text-sec font-medium" data-id="element-71">{row.before}</p>
                </div>
                <div className="px-6 py-6 flex items-start gap-4 bg-primary/5 relative overflow-hidden" data-id="element-72">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-73"></div>
                  <div className="w-6 h-6 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 relative z-10" data-id="element-74">
                    <span className="text-check-green font-bold text-sm" data-id="element-75">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-main font-bold relative z-10" data-id="element-76">
                    {row.after}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}